import React,{ Component } from 'react';
import DataTable from "../../../../components/Table/Table";
import { Link } from 'react-router-dom'

class DomainTable extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const columns = [
            {
                type: "text",
                accessor: "domain",
                name: "Domain",
                filterable: true,
                sortable: true,
                cell: (data) => {
                    const state = {
                        level: "DEBUG",
                        site: data.value,
                        start_date: this.props.selectOpen ? this.props.start_date : null,
                        end_date: this.props.selectOpen ? this.props.end_date : null,
                        delta: this.props.delta,
                        optionsMode: "filter"
                    };

                    return (
                        <div>
                            <Link style={{ color: "black" }} to={{ pathname: "/logging", state }}>
                                {data.value}
                            </Link>
                        </div>
                    );
                },
            },
            {
                type: "text",
                accessor: "categories",
                name: "Categories",
                filterable: true,
                sortable: true,
                cell: (data) => (
                    <div>
                        {Object.values(data.value || {}).sort().join(", ")}
                    </div>
                ),
            },
            {
                type: "text",
                accessor: "allowed",
                name: "Requests Allowed",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                accessor: "denied",
                name: "Requests Denied",
                filterable: true,
                sortable: true,
            },
        ];

        return (
            <div>
                <DataTable
                    id="domains"
                    data={this.props.domains.data || []}
                    columns={columns}
                />
            </div>
        );
    }
}

export default DomainTable;


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportComponents/DomainTable.js